import { render } from "./BrandHeader.vue?vue&type=template&id=523454b9"
import script from "./BrandHeader.vue?vue&type=script&lang=js"
export * from "./BrandHeader.vue?vue&type=script&lang=js"

import "./BrandHeader.vue?vue&type=style&index=0&id=523454b9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__